import React, { FC } from 'react';

import {
  NumberValue,
  ScaleLinear,
  axisBottom,
  Axis as d3Axis,
  select,
} from 'd3';

import styled from 'styled-components';

const StyledGroup = styled.g`
  line {
    display: none;
  }

  text {
    color: #ffffff;
    transform: translateY(5px);
  }
`;

const Axis = ({ axisGenerator }: { axisGenerator: d3Axis<NumberValue> }) => {
  const axisRef = (axis: SVGGElement) => {
    // eslint-disable-next-line no-unused-expressions
    axis &&
      select(axis)
        .call(axisGenerator)
        .call((g) => g.select('.domain').remove());
  };

  return <g ref={axisRef} />;
};

interface Props {
  xScale: ScaleLinear<number, number>;
  innerHeight: number;
  offset?: number;
}

const AxisBottom: FC<Props> = ({ xScale, innerHeight, offset = 0 }) => (
  <StyledGroup transform={`translate(0, ${innerHeight + offset})`}>
    <Axis axisGenerator={axisBottom(xScale).ticks(6)} />
  </StyledGroup>
);

export default AxisBottom;
